import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  organizationListSchema,
  type OrganizationItem,
  type DepartmentListParams,
} from '../types/organization.types';

export const organizationQueryKeys = {
  all: () => ['organization'] as const,
  companies: () => [...organizationQueryKeys.all(), 'companies'] as const,
  departments: (params: DepartmentListParams) =>
    [...organizationQueryKeys.all(), 'departments', params] as const,
  designations: () => [...organizationQueryKeys.all(), 'designations'] as const,
};

export const companyListQueryOptions = () =>
  queryOptions({
    queryKey: organizationQueryKeys.companies(),
    queryFn: async (): Promise<OrganizationItem[]> => {
      const res = await apiClient.get(API.organization.companies);
      return organizationListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export const departmentListQueryOptions = (params: DepartmentListParams = {}) =>
  queryOptions({
    queryKey: organizationQueryKeys.departments(params),
    queryFn: async (): Promise<OrganizationItem[]> => {
      const res = await apiClient.get(API.organization.departments, { params });
      return organizationListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });

export const designationListQueryOptions = () =>
  queryOptions({
    queryKey: organizationQueryKeys.designations(),
    queryFn: async (): Promise<OrganizationItem[]> => {
      const res = await apiClient.get(API.organization.designations);
      return organizationListSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
